import type { ApiResponse } from '../../api/contract';
import type { ApiClient, RequestOptions } from '../../api/http';
import { normalizeFiltersForKind, reportDefinition } from './definition';
import type { ReportsRepository } from './repository';
import type { ReportKind, ReportQuery, ReportResult } from './types';

type ReportingResponse = ApiResponse<'/api/v1/reports/transactions', 'get'>;
export function createRealReportsRepository(
  client: ApiClient,
  accessToken: string | null,
): ReportsRepository {
  const auth: RequestOptions = accessToken === null ? {} : { accessToken };
  return {
    async run(kind, query, signal) {
      const definition = reportDefinition(kind);
      const response = await client.get<ReportingResponse>(definition.path, {
        ...auth,
        query: reportQuery(kind, query),
        signal,
      });
      return mapResult(response.data, response.requestId);
    },
  };
}

export { normalizeFiltersForKind as normalizeReportFilters } from './definition';

function reportQuery(kind: ReportKind, query: ReportQuery): Readonly<Record<string, unknown>> {
  return {
    ...normalizeFiltersForKind(kind, query.filters),
    ...(query.cursor.length === 0 ? {} : { cursor: query.cursor }),
    limit: query.limit,
  };
}

function mapResult(response: ReportingResponse, requestId: string | null): ReportResult {
  return {
    rows: response.data,
    totals: response.totals,
    meta: response.meta,
    nextCursor: response.pagination.nextCursor,
    requestId,
  };
}
